import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthService {

  constructor() {}
  nameToken = 'tokenPrestadorOcap';
  public getToken(): string {
    return localStorage.getItem(this.nameToken);
  }

  public getTokenDecode(): any {
    const jwtHelper: JwtHelperService = new JwtHelperService();
    return jwtHelper.decodeToken(this.getToken());

  }

  public isAuthenticated(): boolean {
    const jwtHelper: JwtHelperService = new JwtHelperService();
    const token = this.getToken();
    console.log('token expirado -> ', jwtHelper.isTokenExpired(token));
    // Check whether the token is expired and return
    // true or false

    if (token === undefined){
      return false;
    }
    return !jwtHelper.isTokenExpired(token);
  }
}
